import { NotFoundPage } from './NotFoundPage';

export { NotFoundPage };
export default NotFoundPage;
